import React, { useState, useRef, useEffect } from "react";
import { Helmet } from "react-helmet";
import HeaderTransprent from "../../components/HeaderTransprent";
import Footer from "../../components/Footer";
import Testimonial2 from "../../ui/Testimonial2";
import ContactForm from "../../ui/ContactForm";
import HWAForm from "../../ui/HWAForm";
import AllCompnayLogo from "../../ui/AllCompnayLogo";
import ButtonPage from "../../ui/ButtonPage";
import JsonData from "../../JsonData/jsonData.json"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { GiCheckMark } from "react-icons/gi";
import { GoArrowUpRight } from "react-icons/go";
import { MdClose } from "react-icons/md";



const Home = () => {

  const formRef = useRef(null);
  const [selectedTab, setSelectedTab] = useState("HWA 2025-26");
  const [selectedTab2, setSelectedTab2] = useState("Awarded To Companies That");
  const [isOpen, setIsOpen] = useState(true);

  const settingstwo = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 6000,
    arrows: false,
    autoplaySpeed: 0,
    cssEase: "linear",
    pauseOnHover: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 2560,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }

    ]
  };

  const settingsthree = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: -1,
    autoplay: true,
    speed: 6000,
    arrows: false,
    autoplaySpeed: 0,
    cssEase: "linear",
    pauseOnHover: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 2560,
        settings: {
          slidesToShow: 5,
          slidesToScroll: -1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 5,
          slidesToScroll: -1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: -1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: -1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: -1
        }
      }

    ]

  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  const handleScrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };


  useEffect(() => {
    setIsOpen(true);
  }, []);


  return (
    <>
      <div className="overflow-hidden">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Happiest Workplaces Research 2026-27 – Recognizing India’s Top Companies for Employee Happiness & Well-Being</title>
          <meta name="description" content="Is your company one of the happiest workplaces? The Happiest Workplaces Research 2026-27, in collaboration with ET HR World, honors organizations prioritizing employee happiness and well-being. Gain industry recognition, attract top talent, and showcase your workplace culture. Apply now!" />
          <meta name="keywords" content="Happiest Workplaces Research, workplace happiness, employee well-being, HR awards 2026-27, workplace culture, employee engagement, best workplaces India, ET HR World" />
          <link rel="canonical" href="https://www.talentplusstrengths.com/#/assessment/home" />
        </Helmet>

        <section className="bg-[#2196F3]/10 bg-cover bg-no-repeat bg-right w-full h-auto" style={{ backgroundImage: `url('/img/home/hero-bg.webp')`, }}>
          <HeaderTransprent />
          <div className="w-full h-full">
            <div className="flex md:flex-row flex-col gap-10 mx-auto px-4 xl:px-0 md:py-16 w-full 2xl:w-9/12 xl:w-11/12 h-full">
              <div className="flex flex-col justify-center space-y-8 mx-auto my-auto pt-10 md:pt-0 md:pb-10 w-full h-full md:text-left text-center">
                <h1 data-aos="fade-right" className="font-bold text-5xl xl:text-6xl textcolor">Success Starts <br /> With a Great  <br /> Work Culture!</h1>
                <div data-aos="fade-right" className="font-medium text-base md:text-lg">
                  <h1 className="pb-4 font-bold text-xl md:text-2xl">Happiest Workplaces Research 2026-27 Recognizing India’s Top Companies That Prioritize Employee Happiness & Well-Being</h1>
                  <p className="pb-2 font-semibold text-[#212121]"> Is your company one of the happiest workplaces?</p>
                </div>
                <div className="flex flex-row justify-center md:justify-start items-center md:items-center gap-4">
                  <ButtonPage text="APPLY FOR HWR 2026-27" onClick={handleScrollToForm} />
                </div>
              </div>
              <div className="flex justify-center items-center w-full">
                <img data-aos="fade-left" src="/img/home/happiest-workplaces-research-2026-27 1.png" alt="re-discover-yourself-using" className="z-0" />
              </div>
            </div>
          </div>
          <div className="mx-auto px-4 xl:px-0 pb-10 md:pb-14 w-full 2xl:w-9/12 xl:w-11/12">
            <div className="border-t md:pt-0 pt-4 border-gray-300"></div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-5 pt-6">
              <div className="text-[#212121] text-base md:text-lg leading-relaxed text-left">
                <span className="font-bold text-[#F51E62]">Know Your </span>
                Happiness Index and Drivers.
              </div>
              <div className="text-[#212121] text-base md:text-lg leading-relaxed text-left">
                <span className="font-bold text-[#F51E62]">Get Access </span>
                to National Benchmarks & Best Practices.
              </div>
              <div className="text-[#212121] text-base md:text-lg leading-relaxed text-left">
                <span className="font-bold text-[#F51E62]">Turn Insights </span>
                into Actions for a Happier Workplace.
              </div>
              <div className="text-[#212121] text-base md:text-lg leading-relaxed text-left">
                <span className="font-bold text-[#F51E62]">Earn Recognition </span>
                at the Happiest Workplaces Awards.
              </div>
            </div>
          </div>
        </section>

        <section className="space-y-16 bg-[#FAFAFA]">
          <div className="flex lg:flex-row flex-col-reverse items-center gap-10 mx-auto px-4 xl:px-0 py-10 w-full 2xl:w-9/12 xl:w-11/12">
            <div className="items-center gap-8 grid lg:grid-cols-2 mx-auto">
              <div className="space-y-8">
                <div>
                  <h2 className="font-bold text-3xl md:text-4xl 2xl:text-5xl text-left capitalize textcolor">Why winning happiest workplaces matters</h2>
                  <p className="pt-4 font-semibold text-[#212121] text-xl">Transform Work into Happiness: The Key to Sustainable Growth</p>
                </div>
                <p className="text-[#212121] text-lg">An average person spends 90,000 hours at work in their lifetime! Yet, the words <span className="font-semibold">‘work’</span> and <span className="font-semibold">‘happiness’</span> are rarely spoken of together. This disconnect often results in <span className="font-semibold">a toxic work culture, low engagement,</span> and <span className="font-semibold">poor productivity</span> — hindering both employee well-being and business success.</p>
                <p className="text-[#212121] text-lg">We believe that making a conscious effort to be <span className="font-semibold">HAPPY is not just a choice—it’s a must-have</span> and a necessity for sustainable growth. It starts with understanding your <span className="font-semibold">current state of happiness at work</span> and continuously evolving <span className="font-semibold"></span>workplace practices, taking purposeful actions to create the <span className="font-semibold">Happiest Workplaces.</span></p>
                <div className="flex flex-row justify-center md:justify-start items-center md:items-center gap-4">
                  <ButtonPage text="APPLY FOR HWR 2026-27" onClick={handleScrollToForm} />
                </div>
              </div>
              <div className="gap-6 grid md:grid-cols-2 p-6">
                <div className="hover:bg-gradient-to-b from-[#F8BBD0] to-transparent p-8 rounded-lg">
                  <div className="flex flex-col justify-start items-start space-y-6">
                    <div className="text-xl textcolor">
                      {/* <img src="/img/home/higher-retention-rates.svg" alt="" className="w-28 h-28" /> */}
                      <img src="/img/home/boost-employee-morale.svg" alt="" className="w-28 h-28" />
                    </div>
                    <h3 className="font-bold text-xl md:text-2xl text-left">Industry Recognition – Stand Out as a Leader</h3>
                  </div>
                  {/* <p className="mt-2 text-[#212121] text-lg">Become a top employer of choice.</p> */}
                </div>
                <div className="hover:bg-gradient-to-b from-[#F8BBD0] to-transparent p-8 rounded-lg">
                  <div className="flex flex-col justify-start items-start space-y-6">
                    <div className="text-xl textcolor">
                      <img src="/img/home/higher-retention-rates.svg" alt="" className="w-28 h-28" />
                    </div>
                    <h3 className="font-bold text-xl md:text-2xl text-left">Attract Talent – Hire the Right Fit</h3>
                  </div>
                  {/* <p className="mt-2 text-[#212121] text-lg">Happier employees lead to higher productivity.</p> */}
                </div>
                <div className="hover:bg-gradient-to-b from-[#F8BBD0] to-transparent p-8 rounded-lg">
                  <div className="flex flex-col justify-start items-start space-y-6">
                    <div className="text-xl textcolor">
                      <img src="/img/home/brand-trust.svg" alt="" className="w-28 h-28" />
                    </div>
                    <h3 className="font-bold text-xl md:text-2xl text-left">Enhance Collaboration – United for Success</h3>
                  </div>
                  {/* <p className="mt-2 text-[#212121] text-lg">Gain recognition as a leading workplace.</p> */}
                </div>
                <div className="hover:bg-gradient-to-b from-[#F8BBD0] to-transparent p-8 rounded-lg">
                  <div className="flex flex-col justify-start items-start space-y-6">
                    <div className="text-xl textcolor">
                      <img src="/img/home/featured.svg" alt="" className="w-28 h-28" />
                    </div>
                    <h3 className="font-bold text-xl md:text-2xl text-left">Build CARE for Better Today – Connect | Act | Respect | Empower</h3>
                  </div>
                  {/* <p className="mt-2 text-[#212121] text-lg">Gain exposure in HR publications and industry reports.</p> */}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-[#FAFAFA] py-20">
          <div className="flex flex-col justify-start mx-auto px-4 xl:px-0 w-full 2xl:w-9/12 xl:w-11/12 h-full">
            <h2 className="font-bold text-3xl md:text-4xl 2xl:text-5xl text-start capitalize textcolor">What is the Happiest Workplaces Research?</h2>
            <p className="pt-4 pr-0 lg:pr-96 text-[#212121] text-lg">The Happiness and Wellbeing Research, in collaboration with ET HR World, honors organizations committed to creating happy, healthy, and high-performing workplaces.
              Its aim to recognize organizations that tirelessly strive to enrich workplaces, both emotionally and intellectually.</p>
            <div className="flex flex-row justify-start items-start my-10">
              <div data-aos="fade-right" className="gap-4 grid grid-cols-2 px-2 text-center">
                {["Awarded To Companies That", "Winners Receive"].map((year) => (
                  <div
                    key={year}
                    onClick={() => setSelectedTab2(year)}
                    className={`flex items-center justify-center space-x-2 text-center rounded-md cursor-pointer transition-all duration-150 py-5 md:px-10 px-2 text-lg font-semibold bg-gradient-to-b lg:whitespace-nowrap whitespace-normal ${selectedTab2 === year
                      ? "from-[#F8BBD0] to-transparent textcolor"
                      : "from-[#212121]/10 to-transparent text-[#212121]"
                      }`}
                  >
                    {/* <span className="">
                      <img src="/img/home/trophy.svg" alt="trophy.png" className={`w-6 h-6 ${selectedTab2 === year ? "textcolor" : " text-[#212121]"}`} />
                    </span> */}
                    <span className="text-center md:text-right">{year}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Image Grid Wrapper */}
            {selectedTab2 === "Awarded To Companies That" && (
              <div className="flex flex-col justify-start items-start space-x-2">
                {/* Content Grid */}
                <div className="gap-6 grid grid-cols-1 md:grid-cols-2 w-full">
                  {/* Left Section */}
                  <div className="flex items-start bg-white shadow-md p-8 rounded-lg">
                    <span className="text-pink-600 text-xl"><GiCheckMark className="w-5 h-5" /></span>
                    <p className="ml-4 text-[#212121] text-xl"><span className="font-semibold">Recognizing Excellence - </span>Celebrating organizations that actively invest in employee happiness and well-being.</p>
                  </div>
                  <div className="flex items-start bg-white shadow-md p-8 rounded-lg">
                    <span className="text-pink-600 text-xl"><GiCheckMark className="w-5 h-5" /></span>
                    <p className="ml-4 text-[#212121] text-xl"><span className="font-semibold">Inspiring Change - </span>Showcasing success stories that motivate and set benchmarks for workplace culture.</p>
                  </div>
                  <div className="flex items-start bg-white shadow-md p-8 rounded-lg">
                    <span className="text-pink-600 text-xl"><GiCheckMark className="w-5 h-5" /></span>
                    <p className="ml-4 text-[#212121] text-xl"><span className="font-semibold">Driving Research - </span>Conducting in-depth studies to identify and share best practices for a thriving workforce.</p>
                  </div>
                </div>
                {/* CTA Button */}
                <div className="flex flex-row justify-center md:justify-start items-center md:items-center gap-4 mt-10">
                  <ButtonPage text="APPLY FOR HWR 2026-27" onClick={handleScrollToForm} />
                </div>
              </div>
            )}
            {selectedTab2 === "Winners Receive" && (
              <div className="flex flex-col justify-start items-start space-x-2">
                {/* Content Grid */}
                <div className="gap-6 grid grid-cols-1 md:grid-cols-2 w-full">
                  {/* Left Section */}
                  <div className="flex items-start bg-white shadow-md p-8 rounded-lg">
                    <span className="text-pink-600 text-xl"><GiCheckMark className="w-5 h-5" /></span>
                    <p className="ml-4 text-gray-700 text-xl"><span className="font-semibold">Prestigious Recognition - </span>Receive the “Happiest Workplaces” Research as a testament to your organization's commitment to employee happiness, health, and productivity.</p>
                  </div>
                  <div className="flex items-start bg-white shadow-md p-8 rounded-lg">
                    <span className="text-pink-600 text-xl"><GiCheckMark className="w-5 h-5" /></span>
                    <p className="ml-4 text-gray-700 text-xl"><span className="font-semibold">Detailed Reporting - </span>Winners receive a comprehensive report with actionable insights, benchmarking data, and detailed analysis on your workplace culture, highlighting strengths and areas for growth.</p>
                  </div>
                  <div className="flex items-start bg-white shadow-md p-8 rounded-lg">
                    <span className="text-pink-600 text-xl"><GiCheckMark className="w-5 h-5" /></span>
                    <p className="ml-4 text-gray-700 text-xl"><span className="font-semibold">Visibility and Exposure - </span>Gain media coverage media coverage, showcasing your organization as a leader in workplace happiness and wellbeing.</p>
                  </div>
                  <div className="flex items-start bg-white shadow-md p-8 rounded-lg">
                    <span className="text-pink-600 text-xl"><GiCheckMark className="w-5 h-5" /></span>
                    <p className="ml-4 text-gray-700 text-xl"><span className="font-semibold">Tell Your Story - </span>A platform to share the organization story and showcase organization’s commitments towards creating a happier world.</p>
                  </div>
                  <div className="flex items-start bg-white shadow-md p-8 rounded-lg">
                    <span className="text-pink-600 text-xl"><GiCheckMark className="w-5 h-5" /></span>
                    <p className="ml-4 text-gray-700 text-xl"><span className="font-semibold">Best Practice Toolkit - </span>Access a valuable collection of practices and case studies to continue building a thriving, fulfilling workplace.</p>
                  </div>
                </div>
                {/* CTA Button */}
                <div className="flex flex-row justify-center md:justify-start items-center md:items-center gap-4 mt-10">
                  <ButtonPage text="APPLY FOR HWR 2026-27" onClick={handleScrollToForm} />
                </div>
              </div>
            )}
          </div>
        </section>

        <section className="space-y-6 mx-auto px-4 xl:px-0 py-20 w-full 2xl:w-9/12 xl:w-11/12 text-center">
          <div className="space-y-2">
            <h1 data-aos="fade-up" className="mx-auto w-full lg:w-[60%] font-bold text-4xl xl:text-5xl capitalize textcolor">Process for the Happiest Workplaces Research 2026-27</h1>
          </div>
          <p className="mx-auto mt-4 w-full lg:w-[70%] text-[#212121] text-xl">We empower organizations to achieve workplace excellence by conducting in-depth employee well-being surveys to measure satisfaction, leveraging real-time workforce analytics and HR audits to strengthen HR strategies, and honoring industry leaders who cultivate a thriving, high-performance culture.</p>
        </section>

        <div className="space-y-16">
          {/* 1 */}
          <section className="flex lg:flex-row flex-col-reverse items-center gap-10 mx-auto px-4 xl:px-0 py-10 w-full 2xl:w-9/12 xl:w-11/12">
            {/* text */}
            <div data-aos="fade-right" className="space-y-6 w-full">
              <span className="font-medium text-[#2196F3] uppercase"></span>
              <h2 className="font-bold text-[#212121] text-3xl md:text-4xl 2xl:text-5xl capitalize">Register for Participation & Launch Employee Experience Survey</h2>
              <p className="text-[#212121] text-xl">Begin by registering your organization for the Happiest Workplaces Research. This simple step allows us to understand your commitment to creating a positive workplace environment.</p>
              <p className="text-[#212121] text-xl">Conduct the Employee Experience Survey across your organization to gather valuable feedback on workplace happiness, well-being, and overall employee experience.</p>
              {/* <ul className="space-y-2 pl-6 text-[#212121] text-lg list-disc">
                <li><span className="font-semibold">Improve Employee Wellbeing –</span> Conduct an employee happiness and wellbeing survey to understand workplace satisfaction and mental health.</li>
                <li><span className="font-semibold">Enhance People Process Design –</span> Assess and optimize HR processes with real employee feedback.</li>
                <li><span className="font-semibold">Boost Workplaces Productivity –</span> Happy employees perform better, leading to increased efficiency and engagement.</li>
                <li><span className="font-semibold">Measure Employee Satisfaction –</span> Gain insights into workplace morale through a quick and effective questionnaire.</li>
              </ul> */}
              {/* <LearnMore text="Learn More" /> */}
            </div>
            {/* img */}
            <div className="w-full">
              <img alt="assessment_survey" data-aos="fade-left" src="/img/home/employee-survey.webp" width={992} height={582} />
            </div>
          </section>

          {/* 2 */}
          <section className="flex lg:flex-row flex-col items-center gap-10 mx-auto px-4 xl:px-0 py-10 w-full 2xl:w-9/12 xl:w-11/12">
            <div className="w-full">
              <img alt="summary_report" data-aos="fade-right" src="/img/home/dashboard-and-insights.webp" width={992}
                height={582} />
            </div>
            {/* text */}
            <div data-aos="fade-left" className="space-y-6 w-full">
              <span className="font-medium text-[#2196F3] uppercase"></span>
              <h2 className="font-bold text-[#212121] text-3xl md:text-4xl 2xl:text-5xl capitalize">Dashboard and Insights</h2>
              <p className="text-[#212121] text-xl">The dashboard provides insights into employee happiness, well-being, engagement, people process effectiveness, key achievements, improvement areas, sentiment analysis, and benchmark data.</p>
              <ul className="space-y-2 pl-6 text-[#212121] text-lg list-disc">
                <li><span className="font-semibold">Comprehensive Employee Insights –</span> The dashboard tracks employee happiness, well-being, and engagement in real time.</li>
                <li><span className="font-semibold">Optimize People Processes –</span> Assess the effectiveness of HR and workplace strategies through data-driven insights.</li>
                <li><span className="font-semibold">Sentiment Analysis for Better Decision-Making –</span> Understand employee emotions and concerns with AI-powered sentiment analysis.</li>
                <li><span className="font-semibold">Benchmarking for Competitive Advantage –</span> Compare employee engagement and well-being metrics against industry benchmarks.</li>
              </ul>
              {/* <LearnMore text="Learn More" /> */}
            </div>
          </section>

          {/* 3 */}
          <section className="flex lg:flex-row flex-col-reverse items-center gap-10 mx-auto px-4 xl:px-0 py-10 pb-20 w-full 2xl:w-9/12 xl:w-11/12">
            {/* text */}
            <div data-aos="fade-right" className="space-y-6 w-full">
              <span className="font-medium text-[#2196F3] uppercase"></span>
              <h2 className="font-bold text-[#212121] text-3xl md:text-4xl 2xl:text-5xl capitalize">Submit Debrief of Happiness and Wellbeing Practices & Certification</h2>
              <p className="text-[#212121] text-xl">Share a detailed report on your organization's happiness and wellbeing initiatives, outlining your strategies, programs, and the impact they have had on employee engagement and productivity.</p>
              <p className="text-[#212121] text-xl">Based on the employee feedback and your submission, your organization will be evaluated and, if it meets the threshold criteria, certified as a Happiest Workplaces.</p>
              <p className="text-[#212121] text-xl">This process is designed to ensure a thorough and transparent evaluation while recognizing organizations truly committed to creating a positive, thriving workplace culture.</p>
              {/* <ul className="space-y-2 pl-6 text-[#212121] text-lg list-disc">
                <li><span className="font-semibold">Recognizing Organizations that Prioritize Employee Well-being –</span> Celebrating companies that invest in workplace happiness and a positive culture.</li>
                <li><span className="font-semibold">Building a Positive Workplaces Culture –</span> A strong focus on employee happiness leads to higher engagement, productivity, and retention.</li>
                <li><span className="font-semibold">Driving Meaningful Change –</span> Together, we support a healthier, more motivated, and more engaged workforce.</li>
                <li><span className="font-semibold">Enhancing Employee Experience –</span> A workplace that values well-being attracts top talent and fosters long-term success.</li>
                <li><span className="font-semibold">Shaping the Future of Work  –</span> Organizations that focus on well-being set new standards for a healthier and more productive workforce.</li>
              </ul> */}
              {/* <LearnMore text="Learn More" /> */}
            </div>
            {/* img */}
            <div className="w-full">
              <img alt="detail_report" data-aos="fade-left" src="/img/home/recognition1.webp"
                width={992}
                height={582} />
            </div>
          </section>
        </div>

        <section className="py-6 bgcolor">
          <div className="flex flex-col justify-start mx-auto px-4 xl:px-0 w-full 2xl:w-9/12 xl:w-11/12 h-full">
            <div className="flex lg:flex-row flex-col justify-center lg:justify-between items-center space-y-8 lg:space-y-0 p-4">
              <h1 className="font-semibold text-white text-4xl lg:text-left text-center leading-tight">Get Recognized as India’s <br />Happiest Workplaces!</h1>
              <button onClick={handleScrollToForm} className="group flex justify-center items-center space-x-3 bg-white hover:bg-[#183889] px-6 py-3 font-semibold text-black hover:text-white text-base uppercase cursor-pointer" >  <span>APPLY FOR HWR 2026-27</span>  <GoArrowUpRight className="w-6 h-6 font-semibold text-black group-hover:text-white" /></button>
            </div>
          </div>
        </section>

        <section className="relative bg-white">
          <div className="absolute inset-0">
            <img className="w-full h-full object-cover object-right lg:object-center" src="/img/home/bg-04.webp" alt="" />
          </div>
          {/* <div className="absolute inset-0"></div> */}
          <div className="flex flex-col justify-start mx-auto px-4 xl:px-0 py-20 w-full 2xl:w-9/12 xl:w-11/12 h-full">
            <div className="relative">
              <div className="w-full text-center">
                <h2 className="pb-2 font-bold text-white text-4xl sm:text-4xl xl:text-6xl">Transforming India Into the</h2>
                <h2 className="font-bold text-white text-4xl sm:text-4xl xl:text-6xl">Happy Workplaces for Everyone</h2>
                <div className="gap-12 grid grid-cols-1 md:grid-cols-3 grid-col-2 mx-auto pt-10">
                  <div className="hover:bg-gradient-to-b hover:from-black/25 hover:to-transparent px-4 py-8 rounded-xl">
                    <img className="mx-auto w-24 h-24" src="/img/home/employees-surveyed.svg" alt="" />
                    <div className="pt-6">
                      <p className="font-bold text-white text-6xl">100K+</p>
                      <p className="mt-2 font-medium text-gray-300 text-sm">Employees Surveyed</p>
                    </div>
                  </div>
                  <div className="hover:bg-gradient-to-b hover:from-black/25 hover:to-transparent px-4 py-8 rounded-xl">
                    <img className="mx-auto w-24 h-24" src="/img/home/organizations.svg" alt="" />
                    <div className="pt-6">
                      <p className="font-bold text-white text-6xl">100+</p>
                      <p className="mt-2 font-medium text-gray-300 text-sm">Organizations</p>
                    </div>
                  </div>
                  <div className="hover:bg-gradient-to-b hover:from-black/25 hover:to-transparent px-4 py-8 rounded-xl">
                    <img className="mx-auto w-24 h-24" src="/img/home/trophy.svg" alt="" />
                    <div className="pt-6">
                      <p className="font-bold text-white text-6xl">100+</p>
                      <p className="mt-2 font-medium text-gray-300 text-sm">Award Distributed</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="flex flex-col justify-start mx-auto px-4 xl:px-0 py-20 w-full 2xl:w-9/12 xl:w-11/12 h-full">
            <h2 className="pb-10 font-bold text-white text-4xl sm:text-4xl xl:text-6xl text-center textcolor">Key Benefits Of HWR</h2>
            <div className="gap-0.5 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
              {JsonData.benefits.map((benefit, index) => (
                <div key={index} className="flex flex-col items-center space-y-5 p-10 text-white text-center" style={{ background: benefit.bgColor }}>
                  <div className="flex justify-center items-center bg-white rounded-full w-24 h-24">
                    <img src={benefit.icon} alt={benefit.title} className="w-16 h-16" />
                  </div>
                  <h3 className="font-semibold text-2xl">{benefit.title}</h3>
                  <p className="pt-2 font-medium text-base">{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="md:bg:right bg-[#2196F3]/10 bg-cover bg-no-repeat bg-center py-20 w-full h-auto" style={{ backgroundImage: `url('/img/home/hero-bg.webp')`, }}>
          <h2 className="font-bold text-3xl md:text-4xl 2xl:text-5xl text-center capitalize textcolor">Glimpse of HWA Event</h2>
          <div className="my-10">
            <div className="flex gap-4 px-4 md:px-10 lg:px-36 xl:px-72 w-full overflow-x-auto md:overflow-visible no-scrollbar justify-start md:justify-center scroll-smooth">
              {["HWA 2025-26", "HWA 2024", "HWA 2023", "HWA 2022"].map((year) => (
                <div
                  key={year}
                  onClick={() => setSelectedTab(year)}
                  className={`flex items-center gap-2 rounded-md cursor-pointer transition-all duration-150 py-3 px-6 text-sm md:text-lg font-semibold whitespace-nowrap flex-shrink-0 md:flex-shrink ${selectedTab === year
                    ? "bg-gradient-to-b from-[#F8BBD0] to-transparent textcolor"
                    : "bg-gradient-to-b from-[#212121]/10 to-white text-[#212121]"
                    }`}
                >
                  <img src="/img/home/trophy.svg" alt="trophy" className="w-5 h-5 md:w-6 md:h-6" />
                  <span>{year}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Image Grid Wrapper */}
          {selectedTab === "HWA 2025-26" && (
            <div className="flex justify-center items-center space-x-2 mt-10">
              {/* Left Side Extra Blocks */}
              <div className="space-y-4 overflow-hidden">
                <div className="flex space-y-10">
                  <Slider {...settingstwo} className="w-full">
                    {JsonData.awardImage25.slice(0, 15).map((awardImage25, index) => (
                      <div className='px-4' key={index}>
                        <img src={awardImage25.url} title='happyplus-happiness-and-wellbeing' alt="happyplus-happiness-and-wellbeing" />
                      </div>
                    ))}
                  </Slider>
                </div>
                <div className="flex space-y-10">
                  <Slider {...settingsthree} className="w-full">
                    {JsonData.awardImage25.slice(15, 30).map((awardImage25, index) => (
                      <div className='px-4' key={index}>
                        <img src={awardImage25.url} title='happyplus-happiness-and-wellbeing' alt="happyplus-happiness-and-wellbeing" />
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          )}

          {selectedTab === "HWA 2024" && (
            <div className="flex justify-center items-center space-x-2 mt-10">
              {/* Left Side Extra Blocks */}
              <div className="space-y-4 overflow-hidden">
                <div className="flex space-y-10">
                  <Slider {...settingstwo} className="w-full">
                    {JsonData.awardImage24.slice(0, 15).map((awardImage24, index) => (
                      <div className='px-4' key={index}>
                        <img src={awardImage24.url} title='happyplus-happiness-and-wellbeing' alt="happyplus-happiness-and-wellbeing" />
                      </div>
                    ))}
                  </Slider>
                </div>
                <div className="flex space-y-10">
                  <Slider {...settingsthree} className="w-full">
                    {JsonData.awardImage24.slice(15, 30).map((awardImage24, index) => (
                      <div className='px-4' key={index}>
                        <img src={awardImage24.url} title='happyplus-happiness-and-wellbeing' alt="happyplus-happiness-and-wellbeing" />
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          )}
          {selectedTab === "HWA 2023" && (
            <div className="flex justify-center items-center space-x-2 mt-10">
              <div className="space-y-4 overflow-hidden">
                <div className="flex space-y-10">
                  <Slider  {...settingstwo} className="w-full" >
                    {JsonData.awardImage23.slice(0, 15).map((awardImage23, index) => (
                      <div className='px-4' key={index}>
                        <img src={awardImage23.url} title='happyplus-happiness-and-wellbeing' alt="happyplus-happiness-and-wellbeing" />
                      </div>
                    ))}
                  </Slider>
                </div>
                <div className="flex space-y-10">
                  <Slider  {...settingsthree} className="w-full" >
                    {JsonData.awardImage23.slice(15, 30).map((awardImage23, index) => (
                      <div className='px-4' key={index}>
                        <img src={awardImage23.url} title='happyplus-happiness-and-wellbeing' alt="happyplus-happiness-and-wellbeing" />
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          )}
          {selectedTab === "HWA 2022" && (
            <div className="flex justify-center items-center space-x-2 mt-10">
              <div className="space-y-4 overflow-hidden">
                <div className="flex space-y-10">
                  <Slider  {...settingstwo} className="w-full" >
                    {JsonData.awardImage22.slice(0, 15).map((awardImage22, index) => (
                      <div className='px-4' key={index}>
                        <img src={awardImage22.url} title='happyplus-happiness-and-wellbeing' alt="happyplus-happiness-and-wellbeing" />
                      </div>
                    ))}
                  </Slider>
                </div>
                <div className="flex space-y-10">
                  <Slider  {...settingsthree} className="w-full" >
                    {JsonData.awardImage22.slice(15, 30).map((awardImage22, index) => (
                      <div className='px-4' key={index}>
                        <img src={awardImage22.url} title='happyplus-happiness-and-wellbeing' alt="happyplus-happiness-and-wellbeing" />
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          )}

        </section>

        <AllCompnayLogo />

        <Testimonial2 />

        <section ref={formRef} className="bg-cover bg-no-repeat py-16" style={{ backgroundImage: `url('/img/home/bg-03.webp')`, }}>
          <div className="flex flex-col justify-start mx-auto px-4 xl:px-0 w-full 2xl:w-9/12 xl:w-11/12 h-full">
            <div className="mx-auto px-4 py-12 w-full">
              <div className="flex lg:flex-row flex-col">
                <div className="flex flex-col justify-center mb-8 md:mb-0 pr-0 md:pr-8 lg:w-1/2">
                  <h1 className="mb-6 font-bold text-4xl md:text-5xl leading-tight textcolor">
                    Ready to leap from feedback to action?
                  </h1>
                  <h2 className="mb-4 font-bold text-gray-800 text-2xl">
                    Invest in your people today.<br />
                    If not now, when?
                  </h2>
                  <p className="text-gray-700 text-lg">
                    Let's build an organization where, people feel good about how they contribute to the whole!
                  </p>
                </div>
                <ContactForm />
              </div>
            </div>
          </div>
        </section>


        {isOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4" role="dialog" aria-modal="true">
            <div className="bg-white w-full max-w-[940px] overflow-hidden shadow-2xl flex flex-col md:flex-row max-h-[90vh]">
              <div className="hidden md:block md:w-1/2">
                <img src="/img/home/happiest-workplaces-awards-2027.png" alt="Happiest Workplaces" className="w-full h-full " />
              </div>
              <div className="w-full md:w-1/2 px-8 pt-4 pb-6 overflow-auto">
                <div className="flex items-end justify-end">
                  <button onClick={() => setIsOpen(false)} aria-label="Close modal" className="top-2 text-[#212121]">
                    <MdClose size={22} />
                  </button>
                </div>
                <h2 className="lg:text-4xl text-3xl font-extrabold textcolortwo pt-2">Recognizing Happiest Workplaces 2026-27</h2>
                <p className="textcolortwo mt-2 mb-4">Together, let's celebrate and inspire a new era of thriving workplaces.</p>
                <HWAForm />
              </div>
            </div>
          </div>
        )}

        {/* <Ready /> */}

        <Footer />
      </div>
    </>
  );
};


export default Home;
